import { render } from "./ProjectsCategory.vue?vue&type=template&id=760afa54&scoped=true"
import script from "./ProjectsCategory.vue?vue&type=script&lang=js"
export * from "./ProjectsCategory.vue?vue&type=script&lang=js"

import "./ProjectsCategory.vue?vue&type=style&index=0&id=760afa54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760afa54"]])

export default __exports__